module.exports = __webpack_public_path__ + "img/goal04_over.97ad8b5a.png";